import React from 'react';
import {Link} from 'react-router-dom';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'

const BillDetails = ({billDetails, onChangeTipPercent, view}) => {
  return (
    <div className="bill-details">
     {
            billDetails.discountByPromoCode?(
              <div className="info-row">
                <div className="content-left">
                  <span>DISCOUNT</span>
                  {billDetails.discount && billDetails.discount.discountType==1?
                    <span> - FLAT ${billDetails.discountByPromoCode} OFF</span>
                    :<span> - {billDetails.discount.discount*100}% OFF</span>
                  }
                </div>
                <div className="content-right">
                   (${billDetails.discountByPromoCode})
                </div>
            </div>
          )
          :null
      }
      <div className="info-row">
        <div className="content-left">
          CRV
        </div>
        <div className="content-right">
          {billDetails && (billDetails.CRV || billDetails.CRV == 0)
              ? `$${billDetails.CRV.toFixed(2)}`
              : 'N/A'}
        </div>
      </div>
      <div className="info-row">
        <div className="content-left">
          Subtotal
        </div>
        <div className="content-right">
          {billDetails && billDetails.subTotal
              ? `$${billDetails.subTotal.toFixed(2)}`
              : 'N/A'}
        </div>
      </div>
      <div className="info-row">
        <div className="content-left">
          Tax
        </div>
        <div className="content-right">
          {billDetails && billDetails.tax
              ? `$${parseFloat(billDetails.tax).toFixed(2)}`
              : 'N/A'}
        </div>
      </div>
      <div className="info-row">
        <div className="content-left">
          Delivery Fee
        </div>
        <div className="content-right">
          {billDetails && billDetails.deliveryFee
            ? `$${billDetails.deliveryFee.toFixed(2)}`
            : 'N/A'}
        </div>
      </div>
      <div className="info-row clearfix">
        <div className="content-left">
          Tip<span className="info-hint-text">{billDetails && billDetails.tip && billDetails.tip.percent? `${billDetails.tip.percent}%` : ''}</span>
        </div>
        <div className="content-right">
          {billDetails && (billDetails.tip || billDetails.tip == 0)
              ? `$${billDetails.tip.amount.toFixed(2)}`
              : 'N/A'}
        </div>
      </div>
      <div className="info-footer-row clearfix">
        <div className="content-left">
          {/* <span>Have a coupon code? <a href="#">Click here</a></span> */}
          TOTAL
        </div>
        <div className="content-right">

          <span className="price-text">
            {billDetails && billDetails.total
                ? `$${billDetails.total.toFixed(2)}`
                : '$0'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BillDetails;



// WEBPACK FOOTER //
// ./src/components/checkout/BillDetails.js